import {
  IsOptional,
  IsNotEmpty,
  IsBoolean,
  ValidateNested,
} from "class-validator";
import { Type } from "class-transformer";

import {
  IFetchAdvancedScore,
  IFetchDoesNotQualify,
  IFetchIntermediateScore,
  IFetchNoviceScore,
  IFetchRetrieverScore,
  IFetchScore,
  IFetchSingle,
  IFetchTriple,
} from "./fetch-score.interface";

// -------------------
export class FetchSingleDto implements IFetchSingle {
  @IsOptional()
  @IsBoolean()
  dog_goes_to_ball?: boolean;

  @IsOptional()
  @IsBoolean()
  picks_up_ball?: boolean;

  @IsOptional()
  @IsBoolean()
  returns_ball?: boolean;
}

// -------------------
export class FetchTripleDto implements IFetchTriple {
  @IsOptional()
  ball_direction?: "left" | "right" | "center";

  @IsOptional()
  @ValidateNested()
  @Type(() => FetchSingleDto)
  ball_result?: FetchSingleDto;
}

// -------------------
export class FetchDoesNotQualifyDto implements IFetchDoesNotQualify {
  @IsOptional()
  @IsBoolean()
  runs_off_course?: boolean;

  @IsOptional()
  @IsBoolean()
  urinates_on_course?: boolean;

  @IsOptional()
  @IsBoolean()
  refusal_to_retrieve?: boolean;

  @IsOptional()
  @IsBoolean()
  does_not_finish_in_time?: boolean;

  @IsOptional()
  @IsBoolean()
  other?: boolean;

  @IsOptional()
  other_description?: string;
}

// -------------------
export class FetchNoviceScoreDto implements IFetchNoviceScore {
  @IsBoolean()
  dog_under_control_at_the_start_line: boolean;

  @IsOptional()
  @ValidateNested()
  @Type(() => FetchSingleDto)
  single_to_center?: FetchSingleDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => FetchSingleDto)
  single_to_left?: FetchSingleDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => FetchSingleDto)
  single_to_right?: FetchSingleDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => FetchDoesNotQualifyDto)
  does_not_qualify?: FetchDoesNotQualifyDto;
}

// -------------------
export class FetchIntermediateScoreDto
  extends FetchNoviceScoreDto
  implements IFetchIntermediateScore
{
  @IsOptional()
  @ValidateNested()
  @Type(() => FetchSingleDto)
  single_to_left_or_right?: FetchSingleDto;
}

// -------------------
export class FetchAdvancedScoreDto implements IFetchAdvancedScore {
  @IsBoolean()
  dog_under_control_at_the_start_line: boolean;

  @IsOptional()
  @ValidateNested()
  @Type(() => FetchSingleDto)
  single_to_center?: FetchSingleDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => FetchSingleDto)
  single_to_left_or_right?: FetchSingleDto;

  @IsOptional()
  @ValidateNested({ each: true })
  @Type(() => FetchSingleDto)
  double_1?: FetchSingleDto[];

  @IsOptional()
  @ValidateNested({ each: true })
  @Type(() => FetchSingleDto)
  double_2?: FetchSingleDto[];

  @IsOptional()
  @ValidateNested()
  @Type(() => FetchDoesNotQualifyDto)
  does_not_qualify?: FetchDoesNotQualifyDto;
}

// -------------------
export class FetchRetrieverScoreDto implements IFetchRetrieverScore {
  @IsBoolean()
  dog_under_control_at_the_start_line: boolean;

  @IsOptional()
  @ValidateNested({ each: true })
  @Type(() => FetchTripleDto)
  triple?: FetchTripleDto[];

  @IsOptional()
  @ValidateNested({ each: true })
  @Type(() => FetchSingleDto)
  double_1?: FetchSingleDto[];

  @IsOptional()
  @ValidateNested({ each: true })
  @Type(() => FetchSingleDto)
  double_2?: FetchSingleDto[];

  @IsOptional()
  @ValidateNested()
  @Type(() => FetchDoesNotQualifyDto)
  does_not_qualify?: FetchDoesNotQualifyDto;
}

export class FetchScoreDto implements IFetchScore {
  //
  @IsNotEmpty()
  @IsBoolean()
  passed: boolean;

  @IsOptional()
  @ValidateNested()
  @Type(() => FetchNoviceScoreDto)
  novice?: FetchNoviceScoreDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => FetchIntermediateScoreDto)
  intermediate?: FetchIntermediateScoreDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => FetchAdvancedScoreDto)
  advanced?: FetchAdvancedScoreDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => FetchRetrieverScoreDto)
  retriever?: FetchRetrieverScoreDto;

  @IsOptional()
  @IsBoolean()
  approved_by_judge?: boolean;

  @IsOptional()
  judge_name?: string;

  @IsOptional()
  judge_number?: string;

  @IsOptional()
  result_type?: string;
}
